import { TPage } from '@data/queries/types'

export const getFetchMoreOffsetPagination = <T>(lastPage: TOffsetPaginatedList<T> | undefined): number | undefined => {
    if (!lastPage) {
        return undefined
    }

    const nextOffset = lastPage.offset + lastPage.limit
    const hasMore = lastPage.total > nextOffset

    return hasMore ? nextOffset : undefined
}

export const getFetchMoreCursorPagination = <T>(lastPage: TCursorPaginatedList<T> | undefined): number | undefined =>
    lastPage?.nextCursor ? lastPage.nextCursor : undefined

export function flattenPaginatedData<TEntry>(pages: TPage<TEntry>[] | undefined): ReadonlyArray<TEntry> {
    return Array.isArray(pages)
        ? pages.reduce((entries, page) => {
              if (!page) {
                  return []
              }
              return [...entries, ...page.entries]
          }, [] as TEntry[])
        : []
}
